import styled from "styled-components";
import { Layout as LayoutCore } from "@components/layout";

export const Layout = styled(LayoutCore)`
  flex-direction: column !important;
  padding: 20px 26px;
`;
